var map = {
	"./banhanguytin/1.png": "8458",
	"./cacung/1.png": "eb08",
	"./chuyencan/1.png": "dda8",
	"./daigiadataha/1.png": "f6b5",
	"./duhanhgia/1.png": "83d0",
	"./thanhsanma/1.png": "a4c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0bd7";